// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2JgxC","paramInput":"JobSimulator_paramInput__3D0U2","input":"JobSimulator_input__1WZfN"};